import './Video.scss'

import React, {useState} from 'react'
import ReactPlayer from 'react-player'
import {useCookies} from '../../cookies/cookies'
import {CookieMissing} from '../../cookies/views/CookieMissing'
import {style} from '../../util/style'

const styles = style('video', ['wrapper', 'player'])

export type VideoType = {
	video: string
	cookie_services?: Array<{id: number}>
}

export const Video: React.FC<VideoType> = ({video, cookie_services}) => {
	if (!video) return null
	const {settings} = useCookies()
	const [isPlaying, setPlaying] = useState(false)

	const notEnabledService = (cookie_services || [])
		.map(({id}) => settings.findServiceById(id))
		.find((service) => service && !service.enabled)

	return (
		<VideoWrapper onClick={() => setPlaying(!isPlaying)}>
			{notEnabledService && <CookieMissing cookie_services={cookie_services} />}
			{!notEnabledService && <VideoPlayer video={video} playing={isPlaying} />}
		</VideoWrapper>
	)
}

export const VideoWrapper: React.FC<{onClick?: () => void}> = ({
	onClick,
	children
}) => (
	<div className={styles.wrapper()} onClick={onClick}>
		{children}
	</div>
)

export const VideoPlayer: React.FC<{video: string; playing?: boolean}> = ({
	video,
	playing = false
}) => (
	<ReactPlayer
		url={video}
		playing={playing}
		height={'100%'}
		width={'100%'}
		controls={true}
		light={true}
		style={{
			position: 'absolute',
			left: 0,
			right: 0,
			zIndex: 1
		}}
		playIcon={<span className={styles.player('play')} />}
	/>
)
